import { render, staticRenderFns } from "./FixedWidthTweakUpper.vue?vue&type=template&id=36cc2d2a&scoped=true&lang=pug&functional=true&"
import script from "./FixedWidthTweakUpper.vue?vue&type=script&lang=js&"
export * from "./FixedWidthTweakUpper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "36cc2d2a",
  null
  
)

export default component.exports